import { h, Fragment } from "preact";
import { useState } from "preact/hooks";

import { Box, Button, Grid, Paper, Stack, Tooltip, Typography } from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

import LoadingButton from "@mui/lab/LoadingButton";


const TimeTableCell = ({ uid, val, manageClick, visible, st, lbl, id }) => {
	//console.log("TimeTableCell", lbl);
	return (
		<Grid
			item
			xs={1}
			onClick={() => {
				manageClick(uid);
			}}
		>
			{visible && (
				<Fragment>
					{[-1, 1].includes(val) && (
						<Typography variant="body1" style="text-align: center; padding-bottom: 2px; padding-top: 2px;">
							-
						</Typography>
					)}
					{[-2, 2].includes(val) && (
						<Paper style="cursor: pointer; text-align: center; padding-bottom: 2px; padding-top: 2px; background-color: rgb(76, 175, 80);">
							<Tooltip title={`${lbl}De ${timeTable2[timeTable[st]].s} à ${timeTable2[timeTable[st]].e}`} placement="bottom" arrow>
								<Typography variant="body1">&nbsp;</Typography>
							</Tooltip>
						</Paper>
					)}
				</Fragment>
			)}
		</Grid>
	);
};
const TimeTableHead = ({ val }) => {
	return (
		<Grid item xs={2}>
			{val !== "" && (
				<Paper style="text-align: center; padding-bottom: 2px; padding-top: 2px;">
					<Typography variant="body1">{val}</Typography>
				</Paper>
			)}
		</Grid>
	);
};
const TimeTableCaption = ({ val }) => {
	return (
		<Grid item xs={1}>
			{val !== "" && (
				<Paper style="text-align: center; padding-bottom: 2px; padding-top: 2px;">
					<Typography variant="body1">{val}</Typography>
				</Paper>
			)}
		</Grid>
	);
};
const timeTable = new Array(
	"08:00",
	"08:30",
	"09:00",
	"09:30",
	"10:00",
	"10:30",
	"11:00",
	"11:30",
	"12:00",
	"12:30",
	"13:00",
	"13:30",
	"14:00",
	"14:30",
	"15:00",
	"15:30",
	"16:00",
	"16:30",
	"17:00",
	"17:30",
	"18:00",
	"18:30",
	"19:00",
	"19:30",
	"20:00"
);

const timeTable2 = {
	"08:00": { s: "08:00", e: "08:30" },
	"08:30": { s: "08:30", e: "09:00" },
	"09:00": { s: "09:00", e: "09:30" },
	"09:30": { s: "09:30", e: "10:00" },
	"10:00": { s: "10:00", e: "10:30" },
	"10:30": { s: "10:30", e: "11:00" },
	"11:00": { s: "11:00", e: "11:30" },
	"11:30": { s: "11:30", e: "12:00" },
	"12:00": { s: "12:00", e: "12:30" },
	"12:30": { s: "12:30", e: "13:00" },
	"13:00": { s: "13:00", e: "13:30" },
	"13:30": { s: "13:30", e: "14:00" },
	"14:00": { s: "14:00", e: "14:30" },
	"14:30": { s: "14:30", e: "15:00" },
	"15:00": { s: "15:00", e: "15:30" },
	"15:30": { s: "15:30", e: "16:00" },
	"16:00": { s: "16:00", e: "16:30" },
	"16:30": { s: "16:30", e: "17:00" },
	"17:00": { s: "17:00", e: "17:30" },
	"17:30": { s: "17:30", e: "18:00" },
	"18:00": { s: "18:00", e: "18:30" },
	"18:30": { s: "18:30", e: "19:00" },
	"19:00": { s: "19:00", e: "19:30" },
	"19:30": { s: "19:30", e: "20:00" },
	"20:00": { s: "20:00", e: "20:30" },
};

const range = (start, end) => {
	const length = end - start;
	return Array.from({ length }, (_, i) => start + i);
};

const TimeTableGridPublic = (props) => {
	// for (let h = 0; h < 25; h++) {
	// 	for (let day = 0; day < 7; day++) {
	// 		console.log(day * 25 + h);
	// 	}
	// }
	//console.log("TimeTableGridPublic", props);
	const [localState, setLocalState] = useState({ slot: undefined });
	const [loadingState, setLoadingState] = useState(false);
	const manageClick = (uid, hh) => {
		console.log("click on cell", uid, hh, props.wk)
		setLocalState({ ...localState, slot: uid, hh: hh });
		props.updt({ conf_meeting: true, wk: props.wk })
	};
	var slots;
	//var wk_lbl;
	switch (props.wk) {
		case 0:
			slots = props.actualDeal.ambassador_slots.slots;

			break;
		case 1:
			slots = props.actualDeal.ambassador_slots1.slots;

			break;
		case 2:
			slots = props.actualDeal.ambassador_slots2.slots;

			break;
		case 3:
			slots = props.actualDeal.ambassador_slots3.slots;

			break;
		case 4:
			slots = props.actualDeal.ambassador_slots4.slots;

			break;
		case 5:
			slots = props.actualDeal.ambassador_slots5.slots;

			break;
		case 6:
			slots = props.actualDeal.ambassador_slots6.slots;

			break;
	}
	console.log("slots", slots, localState, props.actualDeal);
	const confirmAppointment = (suid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/a08bc832061f42d091b8d5bffe89944b/" + props.deal_uid + "/" + suid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setLocalState((state) => ({
							...state,
							done: true,
							slot: undefined,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Fragment>
			{localState.done && (
				<div style="margin-bottom: 20px; width: 100%">
					<Stack>

						<Typography variant="h5" style="margin-top: 20px">
							Félicitations !
						</Typography>
						<Typography variant="body1" style="margin-top: 20px">
							Votre rendez-vous est bien noté
						</Typography>

						{!props.params.internal && <Box
							display="flex"
							alignItems="center"
							justifyContent="space-evenly"
							p={1}
							m={1}

						>
							<Box p={1} >
								<Button
									variant="contained"
									onClick={() => {
										props.handleClose();
									}}
								>
									Rester sur la page
								</Button>
							</Box>
							<Box>
								{/* <Button
									variant="contained"
									onClick={() => {
										//window.location.href = props.tkn;
										//window.location.href = "/dashboardp";
									}}
								>
									Voir mon espace
								</Button> */}
							</Box>
						</Box>}
						{props.params.internal && <Box
							display="flex"
							alignItems="center"
							justifyContent="space-evenly"
							p={1}
							m={1}
						>
							<Box p={1} >
								<Button
									variant="contained"
									onClick={() => {
										//props.handleClose();
										window.location.reload();
									}}
								>
									Fermer
								</Button>
							</Box>
						</Box>}
					</Stack>

				</div>
			)}
			{localState.slot !== undefined && (
				<div style="width: 100%">
					<Stack alignItems={"center"} justifyContent="center">

						<Typography variant="h5" style="margin-top: 20px">
							{" "}
							Confirmez-vous votre demande de rendez-vous le{" "}
							{`${slots[localState.slot].lbl} à
						 ${timeTable2[timeTable[localState.hh]].s}`}{" "}
							?
						</Typography>{" "}

						<Box
							display="flex"
							alignItems="center"
							justifyContent="space-between"
							p={1}
							m={1}

						>
							<Box p={1} >
								<Button
									onClick={() => {
										props.handleClose();
										props.onClose();
									}}
								>
									Annuler
								</Button>
							</Box>
							<Box>
								<LoadingButton
									loading={loadingState}
									variant="contained"
									onClick={() => {
										setLoadingState(true);
										setTimeout(() => {
											confirmAppointment(slots[localState.slot].u);
										}, 1000);
									}}
								>
									Oui
								</LoadingButton>
							</Box>
						</Box>
					</Stack>

				</div>
			)
			}
			{
				localState.slot === undefined && (localState.done !== true) && (
					<Fragment>
						{/* <Grid xs={12}>
						<Typography variant="h5">{wk_lbl}</Typography>
					</Grid> */}
						{range(1, 175).map((i) => {
							//	console.log(i);
							var day = (i - 1) % 7;

							var hh = (i - (1 + day)) / 7;

							const is_in_range = true;
							// timeTable2[timeTable[hh]].s + ":00" >= props.actualDeal.ambassador_regular_start &&
							// timeTable2[timeTable[hh]].s + ":00" <= props.actualDeal.ambassador_regular_end;
							//||
							//(state.ambassador_regular_2 && item[0] >= state.ambassador_regular_start2 && item[0] <= state.ambassador_regular_end2);
							//console.log(timeTable2[timeTable[hh]].s, state.ambassador_regular_start, state.ambassador_regular_end, is_in_range);
							if (!is_in_range) return;
							let val = 1 + (slots[`${i}`] !== undefined);
							return (
								<Fragment>
									{day === 0 ? <TimeTableHead val={timeTable2[timeTable[hh]].s} /> : null}
									{
										<TimeTableCell
											val={val}
											uid={val === 2 ? slots[`${i}`].u : null}
											manageClick={() => manageClick(`${i}`, hh)}
											visible={true}
											st={hh}
											//st={day}
											id={`${i}`}
											lbl={val === 2 ? slots[`${i}`].lbl + " " : ""}
										/>
									}
									{day === 6 ? <Grid item xs={3}></Grid> : null}
								</Fragment>
							);
						})}
					</Fragment>
				)
			}
		</Fragment >
	);
};


export default function MasterWeekViewPublic(props) {
	//console.log("MasterWeekViewPublic", props);
	const [localState, setLocalState] = useState({
		handleClose: props.handleClose, ...props.state,
		internal: props.state.params.internal,
		wk: 0, updt: (a) => { setLocalState({ ...localState, ...a }) },
		tkn: props.state.tkn
	});
	var wk_lbl;
	switch (localState.wk) {
		case 0:
			//slots = props.actualDeal.ambassador_slots.slots;
			wk_lbl = localState.actualDeal.ambassador_slots.lbl;
			break;
		case 1:
			//	slots = props.actualDeal.ambassador_slots1.slots;
			wk_lbl = localState.actualDeal.ambassador_slots1.lbl;
			break;
		case 2:
			//slots = props.actualDeal.ambassador_slots2.slots;
			wk_lbl = localState.actualDeal.ambassador_slots2.lbl;
			break;
		case 3:
			//slots = props.actualDeal.ambassador_slots.slots;
			wk_lbl = localState.actualDeal.ambassador_slots3.lbl;
			break;
		case 4:
			//	slots = props.actualDeal.ambassador_slots1.slots;
			wk_lbl = localState.actualDeal.ambassador_slots4.lbl;
			break;
		case 5:
			//slots = props.actualDeal.ambassador_slots2.slots;
			wk_lbl = localState.actualDeal.ambassador_slots5.lbl;
			break;
		case 6:
			//slots = props.actualDeal.ambassador_slots2.slots;
			wk_lbl = localState.actualDeal.ambassador_slots6.lbl;
			break;
	}
	return (
		<Paper style="padding: 20px; background-color: rgba(244, 246, 248, 0.81);">
			<Grid container spacing={1}>
				{localState.done !== true && (
					<Grid xs={12}>
						<Typography variant="h5">{wk_lbl}</Typography>
					</Grid>)}
				{!localState.conf_meeting && <Grid item xs={1}>
					{localState.wk > 0 && (
						<NavigateBeforeIcon
							onClick={() => {
								setLocalState({ ...localState, wk: localState.wk - 1 });

							}}
						/>
					)}
				</Grid>}
				{!localState.conf_meeting && <Grid item xs={1}>
					{localState.wk <= 5 && (
						<NavigateNextIcon
							onClick={() => {
								setLocalState({ ...localState, wk: localState.wk + 1 });

							}}
						/>
					)}
				</Grid>}
				{!localState.conf_meeting && <Fragment>
					<TimeTableCaption val={"L"} />
					<TimeTableCaption val={"M"} />
					<TimeTableCaption val={"M"} />
					<TimeTableCaption val={"J"} />
					<TimeTableCaption val={"V"} />
					<TimeTableCaption val={"S"} />
					<TimeTableCaption val={"D"} />
					<Grid item xs={3}></Grid>
				</Fragment>}

				<TimeTableGridPublic {...localState} />
			</Grid>
		</Paper >
	);
}
